import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useTopCollections } from "../../services/collectionService";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const CollectionsMenu = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const { data: topCollectionsData } = useTopCollections();
  const topCollections = topCollectionsData?.content || [];

  if (topCollections.length === 0) return;

  return (
    <>
      <li className="nav-item w-100 mt-4 mb-1 px-3">
        <span className="menu-header">{t("sidebar.menu.collections")}</span>
      </li>
      {topCollections.map(({ uuid, name, color, security }) => (
        <li className="nav-item w-100" key={uuid}>
          <Link
            to={`/collections/${uuid}`}
            className={`nav-link d-flex align-items-center position-relative px-3 ${
              location.pathname === `/collections/${uuid}`
                ? "selected fw-semibold"
                : "to-select"
            }`}
            aria-label={name}
          >
            <i
              className="rounded-circle me-2 p-1 flex-shrink-0"
              style={{
                backgroundColor: color,
              }}
            ></i>
            <div className="d-flex align-items-center w-100 text-truncate">
              <span className="text-truncate">
                {name === "Uncategorized" ? t("collections.uncollected") : name}
              </span>
              {security === 1 && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{t("collections.public.badge")}</Tooltip>}
                >
                  <i
                    className="bi bi-globe text-secondary ms-2 flex-shrink-0 small d-flex"
                    aria-hidden="true"
                  ></i>
                </OverlayTrigger>
              )}
            </div>
          </Link>
        </li>
      ))}
    </>
  );
};
